module.exports = __webpack_public_path__ + "bv.svg?6e2a7386e284ef989c3ce24dddd2d77e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bv.svg
// module id = 1016
// module chunks = 27